import * as React from "react";
const Hat = (props) => (
  <svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.24911 9.29087C5.77472 9.29087 5.29475 9.16808 4.92082 8.9281L1.56102 6.73474C0.935943 6.32733 0.562012 5.64086 0.562012 4.89299C0.562012 4.14513 0.935943 3.45866 1.56102 3.05124L4.9264 0.863469C5.67426 0.377917 6.8407 0.377917 7.58298 0.86905L10.926 3.06241C11.5455 3.46982 11.9195 4.15629 11.9195 4.89857C11.9195 5.64086 11.5455 6.32733 10.926 6.73474L7.58298 8.9281C7.20905 9.17367 6.72908 9.29087 6.24911 9.29087ZM6.24911 1.33786C5.93099 1.33786 5.61287 1.41041 5.38405 1.56668L2.02425 3.75446C1.63357 4.01119 1.40475 4.42418 1.40475 4.89299C1.40475 5.3618 1.62799 5.7748 2.02425 6.03153L5.38405 8.22488C5.84727 8.52626 6.66211 8.52626 7.12534 8.22488L10.4684 6.03153C10.8591 5.7748 11.0823 5.3618 11.0823 4.89299C11.0823 4.42418 10.8591 4.01119 10.4684 3.75446L7.12534 1.5611C6.89093 1.41599 6.57281 1.33786 6.24911 1.33786Z"
      fill="#71767B"
    />
    <path
      d="M6.24251 12.5C5.99695 12.5 5.7458 12.4665 5.54488 12.3996L3.76452 11.808C2.92178 11.5289 2.25764 10.6081 2.26322 9.72067L2.2688 7.10315C2.2688 6.87433 2.45856 6.68457 2.68738 6.68457C2.9162 6.68457 3.10596 6.87433 3.10596 7.10315L3.10038 9.72067C3.10038 10.2453 3.5357 10.848 4.03241 11.0155L5.81277 11.6071C6.03601 11.6796 6.44901 11.6796 6.67226 11.6071L8.45261 11.0155C8.94933 10.848 9.38465 10.2453 9.38465 9.72625V7.13664C9.38465 6.90781 9.5744 6.71806 9.80323 6.71806C10.0321 6.71806 10.2218 6.90781 10.2218 7.13664V9.72625C10.2218 10.6136 9.56324 11.5289 8.7205 11.8136L6.94015 12.4052C6.73923 12.4665 6.48808 12.5 6.24251 12.5Z"
      fill="#71767B"
    />
    <path
      d="M11.4899 8.59326C11.261 8.59326 11.0713 8.40351 11.0713 8.17468V4.82605C11.0713 4.59723 11.261 4.40747 11.4899 4.40747C11.7187 4.40747 11.9084 4.59723 11.9084 4.82605V8.17468C11.9084 8.40351 11.7187 8.59326 11.4899 8.59326Z"
      fill="#71767B"
    />
  </svg>
);
export default Hat;
